// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.document-view-header {
  height: 41px;
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 10%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.document-view-title-section {
  margin: 48px 0px;
  padding: 0px 48px;
}

.document-view-title-section-icons {
  width: 24px;
  height: 24px;
}

.document-view-title-section-btn-icons {
  color: var(--primary-main);
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.document-view-pdf-toolbar {
  background-color: #d0d0ce;
  border-bottom: 1px solid #a7a8aa;
  height: 56px;
  padding: 7.5px 48px;
}

.document-view-pdf-page-count {
  width: 65px;
  border: 1px solid #97999b;
  border-radius: 4px;
  background-color: white;
}

.document-view-pdf-file {
  padding: 20px;
  overflow: scroll;
}

.document-view-doc-details {
  border-left: 1px solid #d0d0ce;
  height: 100%;
}

.document-view-doc-details-header-section {
  height: 56px;
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 10%);
}

.document-view-doc-details-expand-btn {
  background-color: var(--primary-main);
  width: 56px;
  height: 56px;
  border: none;
}

.document-view-doc-details-expand-btn-icon {
  width: 24px;
  height: 24px;
  color: white;
}

.document-view-doc-details-collapse-btn {
  background-color: white;
  width: 56px;
  border: none;
}

.document-view-doc-details-collapse-btn-icon {
  width: 24px;
  height: 24px;
  color: #000000;
}

.document-view-doc-details-title {
  background-color: var(--primary-main);
  padding: 16px;
  color: white;
  font-size: 16px;
  font-weight: 700;
}

.document-view-doc-details-body {
  padding: 24px;
  gap: 16px;
}

.document-view-doc-details-body-header-title {
  font-size: 18px;
  font-weight: 600;
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 1rem 0;
}

.document-view-doc-details-body-header-title-disabled {
  font-size: 18px;
  font-weight: 400;
  color: #97999b;
}

.document-view-doc-details-body-header-separator {
  border: 1px solid var(--primary-main);
}

.document-view-doc-details-body-header-separator-disabled {
  border: 1px solid #97999b;
}

.document-view-doc-details-body-content-separator {
  border: 1px solid #a7a8aa;
}

.document-view {
  display: grid;
  grid-template-areas: "pdf details";
  grid-template-columns: 70% 30%;
  max-height: 75vh;
  height: 75vh;

  &.collapsed {
    grid-template-areas: "pdf details";

    grid-template-columns: auto 56px;
  }
}

.pdf {
  grid-area: pdf;
  position: relative;
}

.details {
  grid-area: details;
}

.reset_btn_filter {
  border: none;
  color: var(--primary-main);
  background-color: transparent;
  cursor: pointer;
  text-align: left;
}

.reset_btn_filter:disabled {
  color: #97999b;
  cursor: not-allowed;
}

.reset_btn_filter h4 {
  font-weight: 400;
  font-size: 14px;
}

.coming_soon_alert {
  align-self: center;
  justify-content: center;
  background-color: #e9e784;
  padding: 0 0.5rem;
  border-radius: 4px;
  font-weight: 700;
}

.notAvailable_container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: #f3f3f3;
  height: 70vh;
  flex-direction: column;
  text-align: center;
}

.notAvailable_container h5 {
  font-size: 15px;
  margin: 1rem 0;
}

.notAvailable_container p {
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/css/documentView.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,+CAA+C;EAC/C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,aAAa;EACb,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;;EAEZ;IACE,kCAAkC;;IAElC,gCAAgC;EAClC;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;AACX","sourcesContent":[".document-view-header {\n  height: 41px;\n  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 10%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.document-view-title-section {\n  margin: 48px 0px;\n  padding: 0px 48px;\n}\n\n.document-view-title-section-icons {\n  width: 24px;\n  height: 24px;\n}\n\n.document-view-title-section-btn-icons {\n  color: var(--primary-main);\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.document-view-pdf-toolbar {\n  background-color: #d0d0ce;\n  border-bottom: 1px solid #a7a8aa;\n  height: 56px;\n  padding: 7.5px 48px;\n}\n\n.document-view-pdf-page-count {\n  width: 65px;\n  border: 1px solid #97999b;\n  border-radius: 4px;\n  background-color: white;\n}\n\n.document-view-pdf-file {\n  padding: 20px;\n  overflow: scroll;\n}\n\n.document-view-doc-details {\n  border-left: 1px solid #d0d0ce;\n  height: 100%;\n}\n\n.document-view-doc-details-header-section {\n  height: 56px;\n  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 10%);\n}\n\n.document-view-doc-details-expand-btn {\n  background-color: var(--primary-main);\n  width: 56px;\n  height: 56px;\n  border: none;\n}\n\n.document-view-doc-details-expand-btn-icon {\n  width: 24px;\n  height: 24px;\n  color: white;\n}\n\n.document-view-doc-details-collapse-btn {\n  background-color: white;\n  width: 56px;\n  border: none;\n}\n\n.document-view-doc-details-collapse-btn-icon {\n  width: 24px;\n  height: 24px;\n  color: #000000;\n}\n\n.document-view-doc-details-title {\n  background-color: var(--primary-main);\n  padding: 16px;\n  color: white;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.document-view-doc-details-body {\n  padding: 24px;\n  gap: 16px;\n}\n\n.document-view-doc-details-body-header-title {\n  font-size: 18px;\n  font-weight: 600;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 1rem 0;\n}\n\n.document-view-doc-details-body-header-title-disabled {\n  font-size: 18px;\n  font-weight: 400;\n  color: #97999b;\n}\n\n.document-view-doc-details-body-header-separator {\n  border: 1px solid var(--primary-main);\n}\n\n.document-view-doc-details-body-header-separator-disabled {\n  border: 1px solid #97999b;\n}\n\n.document-view-doc-details-body-content-separator {\n  border: 1px solid #a7a8aa;\n}\n\n.document-view {\n  display: grid;\n  grid-template-areas: \"pdf details\";\n  grid-template-columns: 70% 30%;\n  max-height: 75vh;\n  height: 75vh;\n\n  &.collapsed {\n    grid-template-areas: \"pdf details\";\n\n    grid-template-columns: auto 56px;\n  }\n}\n\n.pdf {\n  grid-area: pdf;\n  position: relative;\n}\n\n.details {\n  grid-area: details;\n}\n\n.reset_btn_filter {\n  border: none;\n  color: var(--primary-main);\n  background-color: transparent;\n  cursor: pointer;\n  text-align: left;\n}\n\n.reset_btn_filter:disabled {\n  color: #97999b;\n  cursor: not-allowed;\n}\n\n.reset_btn_filter h4 {\n  font-weight: 400;\n  font-size: 14px;\n}\n\n.coming_soon_alert {\n  align-self: center;\n  justify-content: center;\n  background-color: #e9e784;\n  padding: 0 0.5rem;\n  border-radius: 4px;\n  font-weight: 700;\n}\n\n.notAvailable_container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  background-color: #f3f3f3;\n  height: 70vh;\n  flex-direction: column;\n  text-align: center;\n}\n\n.notAvailable_container h5 {\n  font-size: 15px;\n  margin: 1rem 0;\n}\n\n.notAvailable_container p {\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
